<div>
    <label class="AudiLabelNormal">Audi Test Page - AudiType Normal</label><br />
    <label class="AudiLabelExtended">Audi Test Page - AudiType Extended</label><br />
    <app-audi-text text="Audi Text Component - order2 - extended (default)" variant="order2" className=""></app-audi-text><br />
    <app-audi-text text="Audi Text Component - order2 - normal" variant="order2" className="audi-type-normal"></app-audi-text>
</div>